module.exports = __webpack_public_path__ + "img/13pts01267.a0cce62d.png";